export default class AbTestProvider {
    constructor(args) {
        // If the args is a string then its our serialized state from the server
        const initialState = typeof args === 'string' ? JSON.parse(args) : {}

        // Provider state
        this._state = initialState
    }

    // Function to check if the experiment and variant you are looking to run is active
    isVariantActive(testId, variantId) {
        return this._state[testId] === variantId
    }

    // Sets the active variant for an experiment
    setVariant(testId, variantId) {
        if (!testId || !variantId) return

        this._state[testId] = variantId
    }

    // Serializes the state for the client
    serialize() {
        return JSON.stringify(this._state)
    }
}
